import { jsx } from 'react/jsx-runtime';
import { ThemeProvider } from '@mui/material';
import { lightTheme } from './light.theme.js';

const ECSThemeProvider = (props) => (jsx(ThemeProvider, { theme: lightTheme, children: props.children }));

export { ECSThemeProvider };
